<template>
  <div style="padding: 10px" class="bloc">
    <div
      style="max-height: 450px"
      v-for="(questionId, id) in questionsId"
      :key="id"
    >
      <div
        class="has-text-left"
        v-show="questionId == parseInt(questionsId[currentSlide])"
      >
        <SectionTitle
          :window="window"
          :type="'slider'"
          :questionId="questionId"
          :index="id"
        />
        <SectionTitleOthers
          :sondage_data_resultats="sondage_data_resultats"
          :questionId="questionId"
          :window="window"
          :type="sondage_vue_type_resultats"
        />
        <BarChart
          style="height: 400px; margin-left: -11px"
          v-show="
            Object.keys(sondage_data_resultats).some(
              (id) => id === questionId
            ) && sondage_vue_type_resultats === 'bar'
          "
          :donnees="sondage_data_resultats[questionId]"
          :questionId="JSON.parse(questionId)"
          :id="id"
        />
        <PieChart
          style="min-height: 410px; margin-left: -11px"
          v-if="
            Object.keys(sondage_data_resultats).some(
              (id) => id === questionId
            ) && sondage_vue_type_resultats === 'pie'
          "
          :resultatQueston="sondage_data_resultats[questionId]"
          :questionId="JSON.parse(questionId)"
          :id="id"
        />
      </div>
      <LibreResultats
        v-if="
          Object.keys(sondage_libre_resultats).some(
            (id) => id === questionId
          ) && questionId == parseInt(questionsId[currentSlide])
        "
        :intitule="sondage_libre_resultats[questionId].intitule"
        :reponses="sondage_libre_resultats[questionId]"
        :window="window"
      />
    </div>
    <div v-if="sondage_vue_resultats === 'slider'">
      <CarouselButtons :questionsId="questionsId"/>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/resultats/charts/BarChart'
import PieChart from '@/components/resultats/charts/PieChart'
import LibreResultats from '@/components/resultats/LibreResultats'
import SectionTitle from '@/components/resultats/section/SectionTitle'
import SectionTitleOthers from '@/components/resultats/section/SectionTitleOthers'
import CarouselButtons from '@/components/resultats/components/CarouselButtons'
import { mapGetters } from 'vuex'

export default {
  name: 'SliderResultats',
  props: {
    window: {
      required: true
    }
  },
  components: {
    BarChart,
    PieChart,
    LibreResultats,
    SectionTitle,
    SectionTitleOthers,
    CarouselButtons
  },
  data () {
    return {
      classButtonAllResults: ''
    }
  },
  computed: {
    ...mapGetters([
      'type_formulaire',
      'sondage_vue_resultats',
      'sondage_vue_type_resultats',
      'sondage_data_resultats',
      'sondage_libre_resultats',
      'currentSlide'
    ]),
    questionsId: function () {
      let arrayDataChart = Object.keys(this.sondage_data_resultats)
      let arrayDataReponsesLibre = Object.keys(this.sondage_libre_resultats)
      let questionsId = arrayDataChart.concat(arrayDataReponsesLibre)
      questionsId.sort()
      return questionsId
    }
  },
  created () {
    this.$store.commit('UNSET_CHARTS_REFS')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/section/SliderResultatsSection.vue